import React from 'react';
import { SkeletonLoader, List } from 'oolib';
import {
  StyledSubLightbox,
  StyledLevelContainer ,
  StyledLevelContent,
} from '../styled';
import { SKELETON_HEIGHT } from '../constants';

export const SubLightbox = ({ 
  top = 0, 
  style, 
  visibility = "visible",
  loading,
  listProps,
  children,
  forwardRef
}) => (
  <StyledSubLightbox
    ref={forwardRef}
    top={top}
    visibility={visibility}
    style={style}
  >
    <StyledLevelContainer >
      <StyledLevelContent>
        {children}
        {loading ? (
          <SkeletonLoader style={{ height: `${SKELETON_HEIGHT}rem` }} />
        ) : (
          listProps && <List {...listProps} style={{ padding: 0 }}/>
        )}
      </StyledLevelContent>
    </StyledLevelContainer >
  </StyledSubLightbox>
);
